import React from 'react';
import recycleBag from '../../../images/recycle-bag.png';
import laundry from '../../../images/laundry.png';
import creditCard from '../../../images/credit-card-new.png';
export default function ServiceAgreement() {
  const tenantName = import.meta.env.VITE_TENANT_NAME;
  return (
    <div className='mt-4 rounded-sm bg-white py-4 px-8 sm:px-14 sm:py-8'>
      <div className='mb-4 flex flex-row items-center justify-center'>
        <p className='go-textblackbold-18'>Take Note Of The Following</p>
      </div>
      <div className='mb-4 flex flex-row items-center '>
        <img src={recycleBag} className='h-10 w-10' alt='Recycle Bag' />
        <p className='go-textblacknormal-16 ml-4'>
          {tenantName === 'laundrycare'
            ? 'Use 13-gal non-stretch trash bags or our reusable bags.'
            : 'Put dirty laundry in trash bags or other closeable bag.'}
        </p>
      </div>
      <div className='mb-4 flex flex-row items-center '>
        <img src={laundry} className='h-10 w-10' alt='Laundry' />
        <p className='go-textblacknormal-16 ml-4'>
          All items are machine-washed and tumble-dried (no dry cleaning). Stain removal isn’t guaranteed, and air-dry
          requests may return slightly damp.
        </p>
      </div>
      <div className='mb-4 flex flex-row items-center '>
        <img src={creditCard} className='h-10 w-10' alt='Credit Card' />
        <p className='go-textblacknormal-16 ml-4'>
          A temporary hold for the estimated total is placed on your card; the final charge is captured after delivery.
        </p>
      </div>
    </div>
  );
}
